import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';

export function getIndustryInsightSets(industryId, isAllocatedTo = true, excludeArchived = false) {
  return function(dispatch, getState) {
    const endpoint = '/insightsets';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        industryId,
        isAllocatedTo,
        excludeArchived
      }
    };

    return makeAPICall(endpoint, options).then(
      response => {
        const insightSets = response.data.insightSets;
        const type = isAllocatedTo ? 'UPDATE_CURRENT_INDUSTRY_ALLOCATED_INSIGHTSETS' : 'UPDATE_CURRENT_INDUSTRY_UNALLOCATED_INSIGHTSETS'
          dispatch({ type, insightSets });
      },
      error => dispatch(APIError(error, 'Error getting currentIndustry InsightSets'))

    );
  };
}

export function addInsightSetToIndustry(industryId, insightSetId) {
  return function(dispatch, getState) {
    const endpoint = '/insightset/membership/industry';
    const options = {
      method: 'POST',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: {
        industryId,
        insightSetId
      }
    };

    return makeAPICall(endpoint, options).then(
      data => {
        dispatch(getIndustryInsightSets(industryId, true));
        dispatch(getIndustryInsightSets(industryId, false));
      },
      error => dispatch(APIError(error, 'Error adding insightSet to currentIndustry'))
    );
  };
}

export function removeInsightSetFromIndustry(insightSet, industryId) {
  return function(dispatch, getState) {
    const endpoint = `/insightset/membership/industry/${insightSet.membershipId}`;
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: { isArchived: true }
    };

    return makeAPICall(endpoint, options).then(
      data => {
        dispatch(getIndustryInsightSets(industryId, true));
        dispatch(getIndustryInsightSets(industryId, false));
      },
      error => dispatch(APIError(error, 'Error removing insightSet from currentIndustry'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/industries/insightSetCreators.js